import { render, staticRenderFns } from "./changeOAndP.vue?vue&type=template&id=f4ea59b6&scoped=true&"
import script from "./changeOAndP.vue?vue&type=script&lang=js&"
export * from "./changeOAndP.vue?vue&type=script&lang=js&"
import style0 from "./changeOAndP.vue?vue&type=style&index=0&id=f4ea59b6&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ea59b6",
  null
  
)

export default component.exports